import { parseFullName, renderCopyHover } from 'helpers';
import { TFunc, useTranslation } from 'libs/i18n';
import { TableColumn } from 'libs/ui';

import { AdminsListItem } from '../../types';

import { renderRole, renderStatus } from './renders';

export const getColumns = (t: TFunc): TableColumn<AdminsListItem>[] => [
  {
    field: 'email',
    title: t('admin.admins.columns.email'),
    width: 300,
    renderCell: (item) => renderCopyHover(item.email),
  },
  {
    field: 'lastName',
    title: t('admin.admins.columns.fullName'),
    sortable: true,
    width: 300,
    renderCell: (item) => renderCopyHover(parseFullName(item)),
  },
  {
    field: 'role',
    title: t('admin.admins.columns.role'),
    width: 300,
    renderCell: (item) => renderRole(item, t),
  },
  {
    field: 'status',
    title: t('admin.admins.columns.status'),
    sortable: true,
    minWidth: 180,
    renderCell: (item) => renderStatus(item, t),
  },
];

export const useColumns = () => {
  const { t } = useTranslation();
  return getColumns(t);
};
